import { Translation } from 'cng-common/features/translations/components/translation'
import { IColumn } from 'core-components/library/list/types'
import { getQBRFormattedFinance } from 'partner360/components/QBR/helpers/getQBRFormattedFinance'
import { IQbrDocumentInitiative } from 'partner360/models/qbr/iQbrDocumentInitiative'
import { QBRRounding } from 'partner360/models/qbr/QBRRounding'

import { TRANSLATION_KEYS } from '../../../../../translations'
import { Incremental, Period, Status } from '../../../../initiativeCard'

export const getDialogContentColumns = (
  rounding: QBRRounding
): IColumn<IQbrDocumentInitiative>[] => {
  return [
    {
      title: TRANSLATION_KEYS.availableInitiativesColumns.name,
      field: 'Name',
      renderFunction: (item) => {
        return <div>{item.Name || '-'}</div>
      },
    },
    {
      title: TRANSLATION_KEYS.availableInitiativesColumns.description,
      field: 'Description',
      renderFunction: (item) => {
        return <div>{item.Description || '-'}</div>
      },
    },
    {
      title: TRANSLATION_KEYS.availableInitiativesColumns.businessUnit,
      field: 'BusinessUnit',
      renderFunction: (item) => {
        return <div>{item.BusinessUnit ? <Translation text={item.BusinessUnit} /> : '-'}</div>
      },
    },
    {
      title: TRANSLATION_KEYS.availableInitiativesColumns.financialGoal,
      field: 'Goal',
      renderFunction: (item) => {
        return (
          <div>
            {typeof item.Goal === 'number' ? getQBRFormattedFinance(item.Goal, rounding) : '-'}
          </div>
        )
      },
    },
    {
      title: TRANSLATION_KEYS.availableInitiativesColumns.incremental,
      field: 'Incremental',
      renderFunction: (item) => {
        return (
          <div>
            {typeof item.Incremental === 'number' ? <Incremental value={item.Incremental} /> : '-'}
          </div>
        )
      },
    },
    {
      title: TRANSLATION_KEYS.availableInitiativesColumns.period,
      field: 'Period',
      renderFunction: (item) => {
        return <Period period={item.Period} />
      },
    },
    {
      title: TRANSLATION_KEYS.availableInitiativesColumns.fundsNeeded,
      field: 'HPInvestmentSum',
      renderFunction: (item) => {
        const hasFunds = typeof item.HPInvestmentSum === 'number'

        return <div>{hasFunds ? getQBRFormattedFinance(item.HPInvestmentSum, rounding) : 'NO'}</div>
      },
    },
    {
      title: TRANSLATION_KEYS.availableInitiativesColumns.owner,
      field: 'Owner',
      renderFunction: (item) => {
        return <div>{item.Owner || '-'}</div>
      },
    },
    {
      title: TRANSLATION_KEYS.availableInitiativesColumns.status,
      field: 'Status',
      width: 150,
      renderFunction: (item) => {
        return <Status isReadonly value={item.Status} />
      },
    },
  ]
}
